<template>
    <button
        @click.prevent="openModal()"
        :disabled="loading"
        type="button"
        :class="{ 'cursor-not-allowed': loading }"
        class="
            mt-3
            inline-flex
            justify-center
            items-center
            ml-2
            py-1
            px-2
            font-semibold
            leading-6
            text-sm
            shadow
            rounded-md
            text-white
            bg-indigo-500
            hover:bg-indigo-400
            transition
            ease-in-out
            duration-150
            mb-3
        "
    >
        Adicionar novo
    </button>

    <div
        class="
            overflow-hidden
            not-prose
            relative
            bg-slate-50
            rounded-xl
            dark:bg-slate-800/25
        "
    >
        <ticto-loading v-if="loading"></ticto-loading>
        <table
            v-if="levels.length"
            class="border-collapse table-auto w-full text-sm"
        >
            <thead>
                <tr class="dark:text-white">
                    <th
                        scope="col"
                        class="text-sm font-medium px-6 py-4 text-left"
                    >
                        ID
                    </th>
                    <th
                        scope="col"
                        class="text-sm font-medium px-6 py-4 text-left"
                    >
                        Nome
                    </th>
                    <th
                        scope="col"
                        class="text-sm font-medium px-6 py-4 text-left"
                    >
                        Pontuação
                    </th>
                    <th
                        scope="col"
                        class="text-sm font-medium px-6 py-4 text-left"
                    >
                        Sequência
                    </th>
                    <th
                        scope="col"
                        class="text-sm font-medium px-6 py-4 text-left"
                    >
                        Tipo
                    </th>
                    <th scope="col" class="p-3 dark:text-slate-200 text-left">
                        Ações
                    </th>
                </tr>
            </thead>
            <tbody class="bg-white dark:bg-slate-800">
                <tr v-for="level in levels" class="">
                    <td
                        class="
                            border-b border-slate-100
                            dark:border-slate-700
                            p-4
                            pl-6
                            text-slate-500
                            dark:text-slate-200
                        "
                    >
                        <div class="flex">#{{ level.id }}</div>
                    </td>
                    <td
                        class="
                            border-b border-slate-100
                            dark:border-slate-700
                            p-4
                            pl-8
                            text-slate-500
                            dark:text-slate-200
                        "
                    >
                        {{ level.label }}
                    </td>
                    <td
                        class="
                            border-b border-slate-100
                            dark:border-slate-700
                            p-4
                            pl-8
                            text-slate-500
                            dark:text-slate-200
                        "
                    >
                        <span>
                            {{ $root.formatCurrency(level.amount) }}
                        </span>
                    </td>
                    <td
                        class="
                            border-b border-slate-100
                            dark:border-slate-700
                            p-4
                            pl-8
                            text-slate-500
                            dark:text-slate-200
                        "
                    >
                        {{ level.place }}
                    </td>
                    <td
                        class="
                            border-b border-slate-100
                            dark:border-slate-700
                            p-4
                            pl-8
                            text-slate-500
                            dark:text-slate-200
                        "
                    >
                        {{ rankingTypes[level.type] }}
                    </td>
                    <td
                        class="border-b border-slate-100 dark:border-slate-700 p-3 text-slate-500 dark:text-slate-200"
                    >
                        <div>
                            <button
                                @click.prevent="openModalToEdit(level.id)"
                                :disabled="loading"
                                type="button"
                                :class="{ 'cursor-not-allowed': loading }"
                                class="inline-flex justify-center items-center ml-2 py-1 px-2 font-semibold leading-6 text-sm shadow rounded-md text-white bg-indigo-500 hover:bg-indigo-400 transition ease-in-out duration-150"
                            >
                                Editar
                            </button>
                            <button
                                @click.prevent="
                                    handleDeleteLevel(level.id)
                                "
                                :disabled="loading"
                                type="button"
                                :class="{ 'cursor-not-allowed': loading }"
                                class="inline-flex justify-center items-center ml-2 py-1 px-2 font-semibold leading-6 text-sm shadow rounded-md text-white bg-red-500 hover:bg-red-400 transition ease-in-out duration-150"
                            >
                                Excluir
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <create-level-modal
        v-if="isModalOpen"
        @fetchLevels="fetch"
        @closeModal="closeModal"
        :level-id="this.levelId"
    />
</template>

<script>
import { TransitionRoot } from "@headlessui/vue";
import FormToggle from "../../../components/forms/FormToggle.vue";
import VueSelect from "../../../components/forms/VueSelect.vue";
import CreateLevelModal from "../modals/CreateLevelModal.vue";
import TictoLoading from "../../../components/layouts/TictoLoading.vue"
import { useToast } from "vue-toastification";

export default {
    components: {
        VueSelect,
        TransitionRoot,
        FormToggle,
        CreateLevelModal,
        TictoLoading
    },

    setup() {        
        const rankingTypes = {
            billing: "Comissionamento"
        }
        const toast = useToast();
        return { toast, rankingTypes };
    },

    data() {
        return {
            isModalOpen: false,
            loading: true,
            levels: [],
            levelId: null,
        };
    },

    mounted() {
        this.fetch();
    },

    methods: {
        closeModal() {
            this.isModalOpen = false;
            this.levelId = null;
        },
        openModal() {
            this.isModalOpen = true;
        },
        openModalToEdit(id) {
            this.isModalOpen = true;
            this.levelId = id;
        },
        fetch() {
            this.loading = true;

            axios
                .get("/api/levels")
                .then(({ data }) => {
                    this.levels = data;
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                });
        },
        handleDeleteLevel(id) {
            if (confirm("Tem certeza que deseja excluir o nível?")) {
                axios
                    .delete(`/api/levels/${id}`)
                    .then(({ data }) => {
                        if (data) {
                            this.toast.success("Nível excluído com sucesso");
                            this.fetch();
                        }
                    })
                    .catch(
                        ({
                            response: {
                                data: { message },
                            },
                        }) => {
                            this.toast.error(message);
                        }
                    );
            }
        },
    },
};
</script>
